module.exports = __webpack_public_path__ + "static/media/GoodMorning_Part2.9001e135.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/GoodMorning/GoodMorning_Part2.mp3
// module id = 141
// module chunks = 0